module.exports = __webpack_public_path__ + "static/img/send.3a3ddac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/send.jpg
// module id = Z4NM
// module chunks = 1